import $http from "$http";
import {util} from 'utils';

export default {
    methods:{
        getContactList(){
            let params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                pageIndex:this.pageIndex,
                pageSize:this.pageSize,
                CustomerId: this.customerId,
            };
            if(this.C_Name !== ''){
                params.C_Name = this.C_Name;
            }

            $http.get('api/Follow/GetContactList', params).then(res => {
                let { Data, Cnt } = res.data;
                util.doResult(this,res,()=>{
                    this.totalSize = Cnt;
                    this.data = Data;
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/common/components/contact-list-dialog/services.js